module.exports = __webpack_public_path__ + "img/1-2101291K219223.0b122f23.jpeg";